export default __webpack_public_path__ + "static/media/amazonBankLogo.3abb74f1.svg";